import { render, staticRenderFns } from "./RankingQDIIOffShoreMonthly.vue?vue&type=template&id=9006773e&scoped=true&"
import script from "./RankingQDIIOffShoreMonthly.vue?vue&type=script&lang=js&"
export * from "./RankingQDIIOffShoreMonthly.vue?vue&type=script&lang=js&"
import style0 from "./RankingQDIIOffShoreMonthly.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingQDIIOffShoreMonthly.vue?vue&type=style&index=1&id=9006773e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9006773e",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingQDIIOffShoreMonthly.vue"
export default component.exports